import { Phone, Target, Rocket, BarChart3 } from 'lucide-react';

const Process = () => {
  const steps = [
    {
      number: '01',
      icon: Phone,
      title: 'Discovery Call',
      description:
        'We start with a free consultation to understand your business, goals, and challenges. No pressure—just a genuine conversation about your needs.',
    },
    {
      number: '02',
      icon: Target,
      title: 'Custom Strategy',
      description:
        'Based on our discovery, we craft a tailored media strategy designed specifically for your industry and target audience.',
    },
    {
      number: '03',
      icon: Rocket,
      title: 'Content Creation',
      description:
        'Our team produces high-quality content—videos, graphics, and posts—that align with your brand and resonate with your audience.',
    },
    {
      number: '04',
      icon: BarChart3,
      title: 'Growth & Optimize',
      description:
        'We continuously monitor performance, analyze data, and optimize our approach to ensure consistent growth and ROI.',
    },
  ];

  return (
    <section id="process" className="py-16 sm:py-24 bg-muted/50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16">
          <span className="inline-block text-accent font-semibold text-sm uppercase tracking-wider mb-3 sm:mb-4">
            Our Process
          </span>
          <h2 className="font-display font-bold text-2xl sm:text-4xl lg:text-5xl text-foreground mb-4 sm:mb-6">
            From Vision to
            <span className="text-accent"> Viral Success</span>
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground">
            A proven, transparent process that takes the guesswork out of growing your brand online.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-accent/0 via-accent/30 to-accent/0 -translate-y-1/2" />

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className="relative group"
              >
                {/* Card */}
                <div className="bg-card border border-border rounded-2xl p-5 sm:p-8 h-full shadow-soft hover:shadow-medium transition-all duration-300 hover:-translate-y-1">
                  {/* Step Number */}
                  <div className="absolute -top-3 sm:-top-4 left-5 sm:left-8 bg-accent text-accent-foreground font-display font-bold text-xs sm:text-sm px-3 sm:px-4 py-0.5 sm:py-1 rounded-full">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="w-10 h-10 sm:w-14 sm:h-14 bg-accent/10 rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:bg-accent/20 transition-colors">
                    <step.icon className="w-5 h-5 sm:w-7 sm:h-7 text-accent" />
                  </div>

                  {/* Content */}
                  <h3 className="font-display font-bold text-base sm:text-xl text-foreground mb-2 sm:mb-3">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-xs sm:text-base leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Arrow for larger screens */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-8 bg-accent rounded-full flex items-center justify-center -translate-y-1/2 z-10">
                    <svg
                      className="w-4 h-4 text-accent-foreground"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
